import styled from "styled-components";

const BoxInfoBasic = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

const InfoRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
`;

const TitleInfo = styled.span`
    font-size: 11px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: 130px;
`;

const ValueInfo = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
`;

const BioBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 4px;
`;

const BioValue = styled.div`
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.6;
    max-height: 160px;
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background: rgba(255,255,255,0.05);
        border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(163, 27, 27, 0.5);
        border-radius: 2px;
    }
`;

function WrestlerBasicInfo({ wrestlerData }: any) {
    return (
        <BoxInfoBasic>
            {wrestlerData.height && (
                <InfoRow>
                    <TitleInfo>Altezza</TitleInfo>
                    <ValueInfo>{wrestlerData.height} cm</ValueInfo>
                </InfoRow>
            )}
            {wrestlerData.weight && (
                <InfoRow>
                    <TitleInfo>Peso</TitleInfo>
                    <ValueInfo>{wrestlerData.weight} kg</ValueInfo>
                </InfoRow>
            )}
            {wrestlerData.place_birth && (
                <InfoRow>
                    <TitleInfo>Luogo di nascita</TitleInfo>
                    <ValueInfo>{wrestlerData.place_birth}</ValueInfo>
                </InfoRow>
            )}
            {wrestlerData.real_face_name && (
                <InfoRow>
                    <TitleInfo>Volto reale</TitleInfo>
                    <ValueInfo>{wrestlerData.real_face_name}</ValueInfo>
                </InfoRow>
            )}
            <InfoRow>
                <TitleInfo>Attivo</TitleInfo>
                <ValueInfo>{wrestlerData.is_active ? 'Sì' : 'No'}</ValueInfo>
            </InfoRow>
            <InfoRow>
                <TitleInfo>Manager</TitleInfo>
                <ValueInfo>{wrestlerData.is_manager ? 'Sì' : 'No'}</ValueInfo>
            </InfoRow>
            {wrestlerData.theme_music && (
                <InfoRow>
                    <TitleInfo>Theme Music</TitleInfo>
                    <ValueInfo>{wrestlerData.theme_music}</ValueInfo>
                </InfoRow>
            )}
            {wrestlerData.bio && (
                <BioBox>
                    <TitleInfo>Bio</TitleInfo>
                    <BioValue>{wrestlerData.bio}</BioValue>
                </BioBox>
            )}
        </BoxInfoBasic>
    );
}

export default WrestlerBasicInfo;
